export class SongData {
    public TimeStamps: number[];

    constructor(pTimeStamps: number[]) {
        this.TimeStamps = new Array<number>();

        for (let i = 0; i < pTimeStamps.length; i++) {
            this.TimeStamps.push(pTimeStamps[i]);
        }
    }
}
